import styled from '@emotion/styled';

import AirdropInfomation from './AirdropInfomation';
import AirdropInteraction from './AirdropInteraction';

type Props = {};

const AirdropContent = (props: Props) => {
  return (
    <MintContentWrapper>
      <AirdropInfomation />
      <AirdropInteraction />
    </MintContentWrapper>
  );
};
const MintContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  width: 400px;
  background-color: #ffffff;
  padding: 32px;
  box-shadow: 0 1px 3px rgb(0 0 0 / 12%), 2px 2px 12px rgb(0 0 0 / 12%);
`;

export default AirdropContent;
